<template>
  <div>
    <v-form @submit.prevent="resend" ref="form" lazy-validation v-model="valid">
      <v-text-field
        v-model="email"
        name="email"
        :label="$t('labels.email')"
        :rules="emailRules"
        required
      ></v-text-field>

      <v-row align="center" justify="center" class="mt-1">
        <v-btn x-large color="info" type="submit" :disabled="!valid" v-text="$t('resend')"></v-btn>
      </v-row>
    </v-form>
  </div>
</template>

<script>
export default {
  name: 'resend',
  data () {
    return {
      valid: true,
      email: null,
      emailRules: [
        v => !!v || this.$t('validations.email_required'),
        v => /.+@.+\..+/.test(v) || this.$t('validations.email_invalid')
      ]
    }
  },
  methods: {
    resend () {
      if (!this.$refs.form.validate()) {
        return false
      }

      this.$store.dispatch('auth/process', {
        type: 'resend',
        callback: document.location.origin + this.$router.resolve({ name: 'auth' }).href,
        payload: {
          username: this.email
        }
      }).then((res) => {
        if (res.status === 204) {
          this.$store.dispatch('addInfo', this.$t('notifications.check_email'))
        }

        this.email = null
        this.$router.push({ name: 'home' })
      }).catch((e) => {
        this.$store.dispatch('addError', e.message)
      })
    }
  }
}
</script>
